module.exports = __webpack_public_path__ + "img/miss7_gastro.ac97c042.svg";